<template>
  <div>
    <b-card
      v-if="!$can('no-access', 'not-allowed')"
      title="Client related Stuff 🔒"
    >
      <b-card-text>Client related stuff.</b-card-text>
    </b-card>
  </div>
</template>

<script>
import { BCard, BCardText } from 'bootstrap-vue'

export default {
  components: {
    BCard,
    BCardText,
    // BLink,
  },
}
</script>

<style>

</style>
